import { __assign, __rest } from "tslib";
import React from 'react';
import { Box, Button, Flex, Stack, Text } from '@chakra-ui/react';
var FormContainer = function (_a) {
    var error = _a.error, children = _a.children, buttonProps = _a.buttonProps, props = __rest(_a, ["error", "children", "buttonProps"]);
    return (React.createElement(Stack, __assign({ direction: 'column', spacing: 4, w: 300 }, props),
        children,
        buttonProps && (React.createElement(Flex, { justifyContent: 'flex-end', pt: 4 },
            React.createElement(Button, __assign({}, buttonProps), buttonProps.children || 'Save'))),
        error && (React.createElement(Box, { my: 2, w: '100%' },
            React.createElement(Text, { textAlign: 'right', color: 'status.error' },
                "Something went wrong: ",
                error)))));
};
export default FormContainer;
//# sourceMappingURL=FormContainer.js.map